export default "__VITE_ASSET__CpaLux7W__"